import React from 'react'
import Button, { ColorButton } from '@/components/Button/Button'
import IconArrowDown from '@/icons/navigation/iconArrowDown'
import IconClose from '@/icons/navigation/iconClose'

import * as styles from './FilterButton.css'

type FilterButtonProps = {
  selectedItem?: string
  children: string
  removeSelectedItem: (payload: { value: string; keyword: string }) => void
  btnType?: 'filter' | 'sort' | 'date'
  onClick?: () => void
  upperCase?: boolean
  showCancelButton?: boolean
  color?: ColorButton
}

const FilterButton = ({
  selectedItem = '',
  children,
  removeSelectedItem,
  btnType = 'filter',
  onClick,
  upperCase = true,
  showCancelButton = true,
  color = 'brandPale',
}: FilterButtonProps) => {
  const handleRemoveFilter = (e: React.MouseEvent) => {
    e.stopPropagation()
    removeSelectedItem({ value: '', keyword: '' })
  }

  const baseButtonProps = {
    onClick,
    upperCase,
    size: 'micro' as const,
    externalClassName: styles.ButtonOverride,
  }

  const buttonProps =
    btnType === 'sort'
      ? {
          ...baseButtonProps,
          variant: 'outline' as const,
          color: 'neutral' as const,
        }
      : {
          ...baseButtonProps,
          variant: selectedItem ? ('solid' as const) : ('outline' as const),
          color: selectedItem ? color : ('neutral' as const),
        }

  const renderButtonContent = () => {
    if (selectedItem) {
      return (
        <>
          {selectedItem}
          {btnType !== 'sort' && showCancelButton && (
            <IconClose
              className={`${styles.ButtonRemoveIcon} ${btnType === 'date' ? styles.ButtonRemoveIconLittle : ''}`}
              onClick={handleRemoveFilter}
            />
          )}
          {btnType !== 'sort' && !showCancelButton && (
            <IconArrowDown className={styles.SelectedButtonDropdownIcon} />
          )}
        </>
      )
    }

    return (
      <>
        {btnType === 'date' ? (
          <span
            className={`${styles.DateLabel} ${color === 'brandPale' ? styles.DateLabelBrand : ''}`}
          >
            {children}
          </span>
        ) : (
          <span>{children}</span>
        )}
        {btnType !== 'date' && (
          <IconArrowDown className={styles.ButtonDropdownIcon} />
        )}
      </>
    )
  }

  return (
    <div className={styles.FilterButton}>
      <Button {...buttonProps}>
        <div className={styles.ButtonLabel}>{renderButtonContent()}</div>
      </Button>
    </div>
  )
}

export default FilterButton
